import {UserState} from '../_reducers/user';

type LocalState = {
    user: UserState;
};

export const getUserIsAuthenticated = ({ user }: LocalState): boolean => {
    return user.isAuthenticated;
};
